import { Page } from '../../components';
import { LearndelGame } from '../../games';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { applyHint } from '../../store/slices/learndleWordSlice';
import '../../games/learndle-word/styles/learndle.css';

function LearndleWordPage() {
  const dispatch = useDispatch();
  const { hintsUsed, hasWon, gameStats } = useSelector(
    (state) => state.learndleWord || {}
  );
  const maxHints = 2;

  const HelpModal = ({ onClose }) => (
    <div className="color-key-modal">
      <div className="color-key-content">
        <div className="color-key-header">
          <h3>How to Play</h3>
          <button
            className="close-button"
            onClick={onClose}
            aria-label="Close help"
          >
            ×
          </button>
        </div>
        <div className="color-key">
          <div className="key-item">
            <div className="key-box correct"></div>
            <span className="key-text">Correct letter & position</span>
          </div>
          <div className="key-item">
            <div className="key-box present"></div>
            <span className="key-text">Letter in word</span>
          </div>
          <div className="key-item">
            <div className="key-box absent"></div>
            <span className="key-text">Not in word</span>
          </div>
        </div>
      </div>
    </div>
  );

  HelpModal.propTypes = {
    onClose: PropTypes.func.isRequired,
  };

  const handleHint = () => {
    dispatch(applyHint());
  };

  const getHintText = () => {
    const hintsRemaining = maxHints - hintsUsed;
    return `Hint (${hintsRemaining} left)`;
  };

  const isHintDisabled =
    hintsUsed >= maxHints || hasWon || gameStats?.completed;

  const getHintCount = () => {
    return Math.max(0, maxHints - hintsUsed);
  };

  return (
    <Page
      maxWidth="sm"
      fullHeight
      padding={0}
      helpModal={HelpModal}
      onHint={handleHint}
      hintDisabled={isHintDisabled}
      hintText={getHintText()}
      hintCount={getHintCount()}
    >
      <LearndelGame word="LEARNED" maxHints={2} />
    </Page>
  );
}

export default LearndleWordPage;
